import { render, staticRenderFns } from "./OurCommunity.vue?vue&type=template&id=b13e3b50&scoped=true&"
import script from "./OurCommunity.vue?vue&type=script&lang=js&"
export * from "./OurCommunity.vue?vue&type=script&lang=js&"
import style0 from "./OurCommunity.vue?vue&type=style&index=0&id=b13e3b50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13e3b50",
  null
  
)

export default component.exports